module.exports = __webpack_public_path__ + "img/box-arrow-in-up.a86d0466.svg";